import styled from 'styled-components';

const StyledContainer = styled.div`
	opacity: 0;
	transition: opacity 0.3s ease;
`;

export { StyledContainer };
